import { FC, useRef } from "react";

import styles from "./shimmer-ui.module.scss";

export interface ShimmerUIProps {}

export const ShimmerUI: FC<ShimmerUIProps> = () => {
  const mountTime = useRef(Date.now());
  const mountDelay = -(mountTime.current % 1400);

  return (
    <div
      className={styles.wrapper}
      style={{ animationDelay: `${mountDelay}ms` }}
    >
      <div data-shimmer className={styles.image} />
    </div>
  );
};
